// extracted by mini-css-extract-plugin
module.exports = {"SearchResultsStyles":"SearchResults_SearchResultsStyles__1H-6h"};